/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateCheckRecipientRequest} from '@cash-web/protos/squareup/franklin/app/check_recipient.pb'
import {CreateCheckRecipientResponse} from '@cash-web/protos/squareup/franklin/app/check_recipient.pb'


export const createCheckRecipient = (request:CreateCheckRecipientRequest, options?: CashRequestOptions) => post<CreateCheckRecipientRequest, CreateCheckRecipientResponse>("/2.0/cash/create-check-recipient", request, {...options, rejectOnError: true })